import { RootState } from "./reducer";

export const getUseAnalytics = (state: RootState) => state.preview.mode ? false : state.analytics;
export const isWidgetDisabled = (state: RootState) => state.modals.uploadOpen || state.modals.popupOpen;
export const getItemTabIndex = (state: RootState, itemIndex: number = -1): number => {
  const { uploadOpen, popupOpen } = state.modals;
  const layout = state.settings.display_type;
  const isItemDisabled = uploadOpen || popupOpen;
  if (isItemDisabled) return -1;

  if (!isItemDisabled && layout === "slider") {
    const { realIndex, slidesPerView } = state.slider;
    const visibleSlidesPerView = state.settings.slideshow_style === "material"
      ? slidesPerView - 1
      : slidesPerView;
    return (itemIndex < realIndex + visibleSlidesPerView && itemIndex >= realIndex)
      ? 0
      : -1;
  }

  if (!isItemDisabled && ["grid", "collage"].includes(layout)) {
    return 0;
  }

  return 0;
};
export const getItemSize = (state: RootState) => {
  const itemWidthPercent = state.size.isDesktopScreen
    ? (100 - (state.settings.item_padding * (state.settings.gallery_photos_per_row - 1))) / state.settings.gallery_photos_per_row 
    : (100 - (state.settings.item_mobile_padding * (state.settings.gallery_mobile_photos_per_row - 1))) / state.settings.gallery_mobile_photos_per_row;
  
  const itemWidth = state.size.widgetWidth * itemWidthPercent / 100;
  
  let itemSize = "size-md";
  
  if (itemWidth < 160) itemSize = "size-xs";
  if (itemWidth >= 160) itemSize = "size-sm";
  if (itemWidth > 240) itemSize = "size-md";
  if (itemWidth > 480) itemSize = "size-lg";
  return itemSize;
};